import React from 'react';
import { useTab } from '../../contexts/TabContext';

/**
 * NotFoundContent — 404 UI shown when a tab path has no matching registry entry.
 */
export default function NotFoundContent({ path }) {
  const { goHome } = useTab();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.code}>404</div>
        <h1 style={styles.title}>요청하신 페이지를 찾을 수 없습니다</h1>
        <p style={styles.message}>
          입력하신 주소가 잘못되었거나, 페이지가 이동 또는 삭제되었을 수 있습니다.
        </p>
        {path && <pre style={styles.pathDetail}>{path}</pre>}
        <div style={styles.actions}>
          <button style={styles.primaryButton} onClick={goHome}>
            홈으로 이동
          </button>
          <button style={styles.secondaryButton} onClick={() => window.history.back()}>
            뒤로 가기
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100%',
    backgroundColor: '#f8fafc',
    padding: '1rem',
  },
  card: {
    textAlign: 'center',
    maxWidth: '480px',
    width: '100%',
    padding: '3rem 2rem',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  code: {
    fontSize: '4rem',
    fontWeight: 700,
    color: '#2d3a52',
    margin: '0 0 0.5rem 0',
    lineHeight: 1,
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#1e293b',
    margin: '0 0 0.75rem 0',
  },
  message: {
    fontSize: '0.925rem',
    color: '#64748b',
    margin: '0 0 1.5rem 0',
    lineHeight: 1.6,
  },
  pathDetail: {
    textAlign: 'center',
    fontSize: '0.8rem',
    color: '#64748b',
    backgroundColor: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '0.75rem 1rem',
    marginBottom: '1.5rem',
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  actions: {
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'center',
  },
  primaryButton: {
    padding: '0.625rem 1.5rem',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#ffffff',
    backgroundColor: '#2d3a52',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  secondaryButton: {
    padding: '0.625rem 1.5rem',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#475569',
    backgroundColor: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    cursor: 'pointer',
  },
};
